import { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';
import DataNotFound from '../ui/loader/data-not-found';
import { ChartMainCard } from '../LeadsDashboardComponents/ChartsHeader';
import { TeamAvailability } from '../LeadsDashboardComponents/StatCardIcons';
import HighchartsReact from 'highcharts-react-official';
import InnerLoader from '../ui/loader/inner-loader';
import Highcharts from "highcharts";

export function ProjectsByStatsChart({ apiData = [], apiLoading }) {


   

  const categories = useMemo(
    () => apiData.map(item => item.status),
    [apiData]
  );

  const totalValueData = useMemo(
    () =>
      apiData.map(item =>
        Number(item.count?.toString().replace(/,/g, ""))
      ),
    [apiData]
  );


  // const chartOptions = useMemo(() => ({
  //   chart: {
  //     type: 'bar',
  //     stacked: false,
  //     toolbar: { show: false },
  //   },
  //   plotOptions: {
  //     bar: {
  //       horizontal: true,
  //       columnWidth: '55%',
  //       borderRadius: 4,
  //     },
  //   },
  //   dataLabels: { enabled: false },
  //   xaxis: {
  //     categories,
  //     labels: {
  //       style: { colors: '#6b7280', fontSize: '13px' },
  //     },
  //   },
  //   yaxis: {
  //     labels: {
  //       style: { colors: '#6b7280', fontSize: '13px' },
  //     },
  //   },
  //   tooltip: {
  //     y: {
  //       formatter: (val) => val.toLocaleString(),
  //     },
  //   },
  //   colors: ['#ff6f28', '#1b84ff'],
  //   grid: {
  //     borderColor: '#e5e7eb',
  //     strokeDashArray: 5,
  //   },
  //   legend: { show: false },
  // }), [categories]);

  // const series = useMemo(() => ([
  //   {
  //     name: 'Total Projects',
  //     data: totalValueData,
  //   },

  // ]), [totalValueData]);


    const chartOptions = useMemo(() => ({
    chart: {
      type: "bar",
      inverted: true,
      backgroundColor: "transparent",
      height: "400px",
      animation: { duration: 800 },
    },
    title: { text: null },
    xAxis: {
      categories,
      labels: {
        style: { color: "#6b7280", fontSize: "13px", cursor: "pointer" },
      },
      gridLineWidth: 0,
    },
    yAxis: {
      title: { text: null },
      labels: { style: { color: "#6b7280", fontSize: "13px" } },
      gridLineColor: "#ff6f28",
      gridLineDashStyle: "Dash",
    },
    plotOptions: {
      series: {
        borderRadius: 6,
        cursor: "pointer",
        states: {
          hover: {
            enabled: true,
            brightness: 0.1,
            halo: {
              size: 6,
              attributes: { fill: "#ff6f28", opacity: 0.2 }
            }
          },
        },
        point: {
          events: {
            // click: function () {
            //   if (onBarClick) onBarClick(this.category, this.y);
            // },
          },
        },
        dataLabels: {
          enabled: true,
          format: "{point.y}",
          style: { color: "#374151", fontWeight: "500" },
        },
      },
      bar: {
        pointWidth: 30,
        pointPadding: 0.1,
        groupPadding: 0.2,
      },
    },
    series: [
      {
        name: "Total Leads",
        data: totalValueData.map((val) => ({
          y: val,
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
            stops: [
              [0, "#ff6f28"]
            ],
          },
        })),
      },
    ],
    tooltip: {
      formatter: function () {
        return `<b>${this.key}</b>: ${this.y.toLocaleString()}`;
      },
      backgroundColor: "#f9fafb",
      borderColor: "#06B6D4",
      borderRadius: 6,
      style: { color: "#111827", fontSize: "13px" },
    },
    legend: { enabled: false },
    credits: { enabled: false },
  }), [categories, totalValueData]);
  return (

    <ChartMainCard
      Icon={<TeamAvailability />}
      iconColor={'bg-theme-orange-light text-theme-orange'}
      heading="Project By Status"
      subHeading={"Status-wise analysis of current project positions"}
    >
     

       {!apiLoading ? (
      
          apiData.length > 0 ? (
        <>
          <div className="max-h-[460px] p-6  flex-1 min-h-0">
            {/* <ReactApexChart
              options={chartOptions}
              series={series}
              type="bar"
              height="100%"
            /> */}
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
          </div>
        </>
      ) :
        <DataNotFound title="Package Data" />

      
       
      ) : (
        <InnerLoader />
      )}

    </ChartMainCard>



  );
}


